// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2)
// version  : 1.0
// updated  : 2026-08-06
// protected: NO
// summary  : Sumber TUNGGAL daftar lokasi (store/gudang/region) yang REGION-AWARE.
//            Fungsi MURNI (tanpa import) supaya mudah diuji. Dipakai untuk membatasi
//            PILIHAN dropdown store/region sesuai scope pengguna — Owner=global,
//            Kacab/Admin=region-nya, Staff Store=store-nya. Region tetap ditegakkan
//            backend/RLS (ini hanya lapisan tampilan agar tak membingungkan & tak bocor halus).
// =============================================================================
export const GUDANG_BY_REGION = { SBY: "GUDANG_SBY", SMD: "GUDANG_SMD" };
export const STORE_BY_REGION = { SBY: "STORE_AREMA", SMD: "STORE_BORNEO" };
export const WAREHOUSES = ["GUDANG_SBY", "GUDANG_SMD"];
export const STORES = ["STORE_AREMA", "STORE_BORNEO"];

// Region tiap role (fallback bila me.region kosong). OWNER = GLOBAL (lihat semua).
export const REGION_BY_ROLE = {
  OWNER: "GLOBAL",
  KACAB_SBY: "SBY", KACAB_SMD: "SMD",
  ADMIN_PRODUKSI_SBY: "SBY", ADMIN_PRODUKSI_SMD: "SMD",
  ADMIN_GUDANG_SBY: "SBY", ADMIN_GUDANG_SMD: "SMD",
  STAFF_STORE_AREMA: "SBY", STAFF_STORE_BORNEO: "SMD",
};
export const STORE_BY_ROLE = { STAFF_STORE_AREMA: "STORE_AREMA", STAFF_STORE_BORNEO: "STORE_BORNEO" };

// Region efektif pengguna: utamakan me.region, fallback ke peta role.
export const userRegion = (me) => (me && (me.region || REGION_BY_ROLE[me.role])) || "";
export const isGlobalScope = (me) => { const r = userRegion(me); return !r || r === "GLOBAL"; };

// Daftar region yang boleh dilihat/dipilih pengguna.
export const allowedRegions = (me) => (isGlobalScope(me) ? ["SBY", "SMD"] : [userRegion(me)]);

// Gudang yang boleh dipilih sesuai scope.
export const allowedWarehouses = (me) =>
  allowedRegions(me).map((r) => GUDANG_BY_REGION[r]).filter(Boolean);

// Store yang boleh dipilih sesuai scope. Staff Store: HANYA store-nya sendiri.
export const allowedStores = (me) => {
  const s = me && STORE_BY_ROLE[me.role];
  if (s) return [s];
  return allowedRegions(me).map((r) => STORE_BY_REGION[r]).filter(Boolean);
};

// Semua lokasi (gudang + store) sesuai scope — untuk filter lokasi (Opname/Mutasi).
export const allowedLocations = (me) => [...allowedWarehouses(me), ...allowedStores(me)];
